import { getSocket, SocketDataType } from './WebsocketV1getSocket';
import { remove } from 'lodash';
import { SocketIOCache } from 'src/utils/socket_io';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';
import { Common } from 'src/AppState/Common';

type StateSocketType =
    | {
          type: 'notInit';
      }
    | {
          type: 'init';
      }
    | {
          type: 'ready';
          data: SocketDataType;
      };

type CallbackType = (data: unknown) => void;

const createNotInit = (): StateSocketType => ({
    type: 'notInit',
});

export class WebsocketV1 {
    private socketCache: SocketIOCache;
    private readonly websocket_host: string;
    private stateSocket: StateSocketType;
    private subscribeMap: Map<string, Array<CallbackType>>;

    private constructor(private readonly common: Common) {
        this.socketCache = new SocketIOCache();
        this.websocket_host = this.common.appEnvParams.websocketHost;
        this.stateSocket = {
            type: 'notInit',
        };
        this.subscribeMap = new Map();
    }

    public static get = AutoWeakMap.create((common: Common) => new WebsocketV1(common));

    private async init(): Promise<void> {
        if (this.stateSocket.type !== 'notInit') {
            return;
        }
        this.stateSocket = {
            type: 'init',
        };

        console.info('WebsocketV2 - connection starting');

        const createSocket = await this.socketCache.getByHost(this.websocket_host);

        getSocket(createSocket)
            .then((socketData: SocketDataType) => {
                console.info('WebsocketV2 - connection started');

                this.stateSocket = {
                    type: 'ready',
                    data: socketData,
                };

                socketData.socket.on('disconnect', () => {
                    console.info('WebsocketV2 - disconnect');
                    this.stateSocket = createNotInit();
                    setTimeout(() => {
                        this.init().catch((e) => console.error(e));
                    }, 0);
                });

                for (const [id, callbackList] of this.subscribeMap.entries()) {
                    for (const callback of callbackList) {
                        socketData.subscribe(id, callback);
                    }
                }
            })
            .catch((error) => {
                console.error(error);
                this.stateSocket = {
                    type: 'notInit',
                };
                setTimeout(() => {
                    this.init().catch((e) => console.error(e));
                }, 3000);
            });
    }

    private addCallback(id: string, callback: CallbackType): void {
        this.getCallbackList(id).push(callback);
    }

    private removeCallback(id: string, callback: CallbackType): void {
        const callbacks = this.getCallbackList(id);
        remove(callbacks, (item) => item === callback);
    }

    private getCallbackList(id: string): Array<(data: unknown) => void> {
        const list = this.subscribeMap.get(id);
        if (list !== undefined) {
            return list;
        }
        const newList: Array<(data: unknown) => void> = [];
        this.subscribeMap.set(id, newList);
        return newList;
    }

    public subscribe(id: string, callback: (data: unknown) => void): void {
        this.init().catch((e) => console.error(e));
        this.addCallback(id, callback);

        if (this.stateSocket.type === 'ready') {
            this.stateSocket.data.subscribe(id, callback);
        }
    }

    public unsubscribe(id: string, callback: CallbackType): void {
        this.removeCallback(id, callback);
        if (this.stateSocket.type === 'ready') {
            this.stateSocket.data.unsubscribe(id, callback);
        }
    }

    public emit(id: string, data: unknown): void {
        if (this.stateSocket.type === 'ready') {
            this.stateSocket.data.emit(id, data);
        }
    }
}

/*
$appState.websocketV1.subscribe('138040:Wallet', (data) => {
    console.info('z socketa - callback1', data);
});
$appState.websocketV1.subscribe('138040:Wallet', (data) => {
    console.info('z socketa - callback2', data);
});
$appState.websocketV1.subscribe('138040:Wallet', (data) => {
    console.info('z socketa - callback3', data);
});
*/

// socket.subscribe(id + ':Chat', response => resolve(response.body));
// socket.subscribe(id + ':Chat', response => resolve(response.body));
